import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import KeywordSuggestions, {
  KEYWORD_SUGGESTIONS_OPTIONS,
} from '../KeywordSuggestions';
import SearchAreaSuggestions from '../SearchAreaSuggestions';
import UseMyLocationButton, {
  USE_MY_LOCATION_BUTTON_OPTIONS,
} from '../../atoms/UseMyLocationButton';
import useSearchResultsLogic from '../SearchResults/useSearchResultsLogic';

const HORIZONTAL_SEARCH_RESULTS_CONSTS = {
  SUGGESTION_TYPE_STYLES: {
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.CATEGORY_SUGGESTIONS]: {
      emphasis: true,
      heading: 'Category',
      highlightMatch: false,
      hoverIcon: true,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.PROFILE_SUGGESTIONS]: {
      emphasis: true,
      heading: 'Business Name',
      highlightMatch: false,
      hoverIcon: true,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.RECENT_SEARCHES]: {
      emphasis: false,
      heading: 'Recent Searches',
      highlightMatch: false,
      hoverIcon: true,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.POPULAR_SEARCHES]: {
      emphasis: false,
      heading: 'Popular Searches',
      highlightMatch: false,
      hoverIcon: true,
    },
  },
  USE_MY_LOCATION_BUTTON_SIZE: USE_MY_LOCATION_BUTTON_OPTIONS.SIZES.MD,
};

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledSearchAreaContainer = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
`;

const StyledSearchAreaSuggestionsContainer = styled.div`
  flex-grow: 1;
`;

const StyledKeywordContainer = styled.div`
  display: flex;
`;

const HorizontalSearchResults = ({ className, handleSearchResults }) => {
  const {
    showKeywordSuggestions,
    showSearchAreaSuggestions,
    showSuggestions,
  } = useSearchResultsLogic();

  if (!showSuggestions) return <></>;
  return (
    <StyledContainer className={className}>
      {showSearchAreaSuggestions && (
        <StyledSearchAreaContainer>
          <StyledSearchAreaSuggestionsContainer>
            <SearchAreaSuggestions />
          </StyledSearchAreaSuggestionsContainer>
          <UseMyLocationButton
            size={HORIZONTAL_SEARCH_RESULTS_CONSTS.USE_MY_LOCATION_BUTTON_SIZE}
          />
        </StyledSearchAreaContainer>
      )}
      {showKeywordSuggestions && (
        <StyledKeywordContainer>
          <KeywordSuggestions
            suggestionTypeStyles={
              HORIZONTAL_SEARCH_RESULTS_CONSTS.SUGGESTION_TYPE_STYLES
            }
            handleSearchResults={handleSearchResults}
          />
        </StyledKeywordContainer>
      )}
    </StyledContainer>
  );
};

const horizontalSearchResultsPropTypes = {
  className: PropTypes.string,
};
const horizontalSearchResultsDefaultProps = {
  className: undefined,
};

HorizontalSearchResults.propTypes = horizontalSearchResultsPropTypes;
HorizontalSearchResults.defaultProps = horizontalSearchResultsDefaultProps;
export default HorizontalSearchResults;
export {
  horizontalSearchResultsDefaultProps,
  horizontalSearchResultsPropTypes,
};
